import React from 'react';
import { Button, Col, message, Modal, Row, Steps ,Select} from 'antd';
import { Table } from "components/table";
import { Map, List } from 'immutable';
import { getDataFromQueryString } from "../../utils";
import { DB_ONBOARDING_COLS } from "constants/table-columns";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { fetchDBOnBoardingList } from "actions";
import { STATE_STATUS } from "constants/state-status";
import { CompanyService, DBOnBoardingService, PaymentProgramService } from '../../services';

const Tabs = Map({
    docsPending: {
        label: "Docs Pending",
        key: 'DOCS_PENDING',
        id: 1,
        this_stage_id: 38
    },
    docsReview: {
        label: "Docs Review",
        key: 'DOCS_REVIEW',
        id: 2,
        this_stage_id: 39

    },
    eSignPending: {
        label: "eSign Pending",
        key: 'ESIGN_PENDING',
        id: 3,
        this_stage_id: 40
    },
    eSignComplete: {
        label: "Onboarded",
        key: 'ESIGN_COMPLETED',
        id: 4,
        this_stage_id: 41
    },
});


class DBOnboarding extends React.Component {
    state = {
        selectedTab: "DOCS_PENDING",
        currentPage: 1,
        showAssignModal : false,
        userAssignRemarks: "",
        selfAssign: "",
        selectedAgent: "",
        usersList : List(),
        dbCount  : Map()
    }
    pageSize = 20;
    selectedRows = List();

    componentDidMount() {
        DBOnBoardingService.fetchDbListCount().then(({ data }) => {
            this.setState({
                dbCount: Map(data)
            });
        });
        CompanyService.getUsersList("DB Onboarding").then(({ data }) => {
            this.setState({
                usersList: List(data)
            });
        });
        this.props.fetchDBOnBoardingList(getDataFromQueryString('stage') , this.state.currentPage, this.pageSize, {});
        this.setState({
            selectedTab: getDataFromQueryString('stage')
        });
    }


    onChangeTab = activeIndex => {
        const stage = Tabs.toList().find((_, index) => index == activeIndex);
        this.setState({
            selectedTab: stage.key,
            currentPage: 1,
        }, () => {
            this.props.history.replace(
                `/app/db-onboarding/?stage=${stage.key}`
            );
            this.forceUpdate();
            this.props.fetchDBOnBoardingList(getDataFromQueryString('stage') , this.state.currentPage, this.pageSize, {});
        });
    }

    onFilter = (_) => {
        this.props.fetchDBOnBoardingList(getDataFromQueryString('stage') , this.state.currentPage, this.pageSize, _);
    }

    selfAssignCase = (id) => {
        this.setState({
            selfAssign: id,
            showAssignModal: !this.state.showAssignModal,
            selectedAgent: "",
            userAssignRemarks: ""
        });
    }

    get showRowSelection() {
        const { permissions } = this.props;
        if (this.state.selectedTab == 'DOCS_REVIEW' && (permissions.size && permissions.get("page_db_onboarding_bulk_assign"))) {
            return false;
        } else {
            return true;
        }
    }

    onPageChange = (page, pageSize) => {
        this.setState({
            currentPage: page
        }, () => {
            this.props.fetchDBOnBoardingList(getDataFromQueryString('stage') , page, pageSize, {});
        });
    }

    onBoardinTable = () => {
        const {permissions} = this.props;
        console.log("permissions.get" ,permissions && permissions.size &&  permissions.get("page_dbonboarding_edit"));
        return <Table
            columns={DB_ONBOARDING_COLS}
            checkedColumns={[]}
            filterColumns={DB_ONBOARDING_COLS.filter(_ => _.is_filter_applicable).map(_ => _.dataIndex).toList().toArray()}
            data={
                this.props.dbList.size ? this.props.dbList
                .map(_ => {
                    let row = _;
                    row.split = ([
                        this.state.selectedTab == 'DOCS_REVIEW' ? permissions.size && permissions.get("page_dbonboarding_edit")&& <Button type={"link"} size={"small"} onClick={this.selfAssignCase.bind(null, _.action_task_id)}> {_.assigned_user ? 'Re-assign' :  'Assign'}</Button> : <p>-</p>
                    ]);
                    return row;
                })
                .toList() : List()
            }
            showFooter={false}
            showPaginationOnly={false}
            bulkActionSelectedKey={"action_task_id"}
            customButtonTexts={["Assign"]}
            showCustomButton={this.selectedRows.size}
            selectedRowKeys={this.selectedRows}
            
            custonButtonIcons={[]}
            noRowSelection = {this.showRowSelection}
            onRowSelection={this.onRowSelection}
            onFilter={this.onFilter}
            showTopSection={true}
            keyFilter={"action_task_id"}
            onCustomButtonClicks={[this.handleAssignCaseModal]}
            showColumnSelector={false}
            showHeader={true}
            pagination={{
                current: this.state.currentPage,
                showSizeChanger: true,
                defaultPageSize: 20,
                pageSizeOptions: [
                    "10",
                    "20",
                    "50",
                    "100",
                    "500"
                ],
                position: "bottom",
                total: this.props.dbListCount,
                onChange: (page, pageSize) =>
                    this.onPageChange(page, pageSize),
                onShowSizeChange: this.onPageSizeChange,
            }}
            loading={
                this.props.dbListFetchStatus !== STATE_STATUS.FETCHED &&
                this.props.dbListFetchStatus !== STATE_STATUS.UPDATED
            }
            editable={true}
            className={"inbox-table"}
        />
    }

    handleAssignCaseModal = () => {
        this.setState({
            showAssignModal: !this.state.showAssignModal,
            selectedAgent: "",
            userAssignRemarks: "",
            selfAssign: ""
        });
    }

    clearData = () => {
        this.selectedRows = List();
        this.setState({
            showAssignModal: !this.state.showAssignModal,
            selectedAgent: "",
            userAssignRemarks: "",
            selfAssign: ""
        });
    }

    assignCases = () => {
        const { selectedAgent, userAssignRemarks, currentPage, selfAssign } = this.state;
        if (selfAssign && userAssignRemarks.length) {
            DBOnBoardingService.assignCase(selfAssign, userAssignRemarks, this.props.userDetails.id).then((response) => {
                if (response.status === 201) {
                    message.success("Case Assigned Successfully");
                    this.props.fetchDBOnBoardingList(getDataFromQueryString('stage') , this.state.currentPage, this.pageSize, {});
                }
                this.clearData();
            }).catch((err) => {
                this.clearData();
                if (err.non_field_errors) {
                    message.error(err.non_field_errors[0]);
                } else {
                    message.error("Something went wrong!");
                }
            });

        } else if (selectedAgent && userAssignRemarks.length && this.selectedRows.size) {
            message.loading("Case Assigning ... ");
            PaymentProgramService.bulkAssignCases(this.selectedRows, userAssignRemarks, selectedAgent).then((response) => {
                if (response.status === 200) {
                    message.success("Case Assigned Successfully");
                    this.handleAssignCaseModal();
                    this.selectedRows = List();
                    this.props.fetchDBOnBoardingList(getDataFromQueryString('stage') , this.state.currentPage, this.pageSize, {});
                }
            }).catch((err) => {
                this.clearData();
                if (err.non_field_errors) {
                    message.error(err.non_field_errors[0]);
                } else {
                    message.error("Something went wrong!");
                }
            });
        }
    }

    renderAssignCasesModal = () => {
        const { permissions } = this.props;
        console.log("in render aassign case modal" , )
        return (
            <Modal
                title="Assign Cases"
                visible={this.state.showAssignModal}
                onOk={this.assignCases}
                onCancel={this.handleAssignCaseModal}
            >
                {!this.state.selfAssign && permissions.size && permissions.get("page_db_onboarding_bulk_assign") &&
                    <>
                        <label>Select Agent</label>
                        <Select placeholder="Select Agent" className="mb-10 mt-5" value={this.state.selectedAgent || undefined} onChange={(_) => this.setState({ selectedAgent: _ })} style={{ width: "100%" }}>
                            {this.state.usersList.size && this.state.usersList.map((_, k) => (
                                <Option value={_.id} key={k}>{_.full_name}</Option>
                            ))}
                        </Select>
                    </>
                }
                <label style={{ marginTop: 15 }}>Remarks</label>
                <textarea
                    rows="4"
                    className="mt-5 w-100"
                    style={{
                        borderColor: "#d9d9d9"
                    }}
                    value={this.state.userAssignRemarks}
                    onChange={(_) => this.setState({ userAssignRemarks: _.target.value })}
                />
            </Modal>
        );
    }

    onRowSelection = (_) => {
        let filterTotalRow = _.filter(_ => (_));
        this.selectedRows = filterTotalRow;
        this.forceUpdate();
    }

    render() {
        console.log("in renderrr" , this.state.selfAssign, this.props.permissions);
        return (
            <Row>
                <Col span={24} className={"p-5"}>
                    <Steps
                        className={"stage-tabs normal-steps-height"}
                        type={"navigation"}
                        size={"small"}
                        current={Tabs.toList().findIndex((_) => _.key == this.state.selectedTab)}
                        onChange={this.onChangeTab}
                        style={{
                            marginBottom: 10,
                            boxShadow: "0px -1px 0 0 #e8e8e8 inset",
                            overflowX: "scroll"
                        }}
                    >
                        {Tabs.map(_ => {
                            return (<Steps.Step
                                status={null}
                                key={_.id}
                                title={
                                    <div className="d-flex justify-content-space-between" style={{
                                        alignItems: "start",
                                        width: "100%"
                                    }}>
                                        <div>{_.label}<span>    ({this.state.dbCount.get(_.key.toLowerCase()) || 0})</span></div>
                                    </div>
                                }
                            />);
                        }).toList()}
                    </Steps>
                    {this.onBoardinTable()}
                    {this.renderAssignCasesModal()}
                </Col>
            </Row>
        )
    }
}

DBOnboarding.propTypes = {
    permissions: PropTypes.object,
    userDetails: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        dbList : List(state.dbOnBoarding.get('dbOnBoardingList') , []),
        dbListFetchStatus : state.dbOnBoarding.get('status'),
        permissions: state.user.get("permissions"),
        userDetails: state.user.get("data"),
        dbListCount :  state.dbOnBoarding.get('count' , 0)
    }
};

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        fetchDBOnBoardingList
    }, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(DBOnboarding);
